import { takeLatest } from 'redux-saga'
import {
	call,
	select,
	put,
} from 'redux-saga/effects'

import callAny from './helpers/call_any'
import actionTypes from 'redux/actions/actionTypes'
import { storeSync } from 'sync'
import activityBanksActions from 'redux/actions/activityBanksActions'
import canReplace from 'redux/selectors/creationTool/activityBanks/canReplaceSelector'
import formatError from './helpers/error_formatter'
import userDataJwtSelector from '../selectors/user/user_data_jwt_selector'
import currentViewSelector from '../selectors/ui/currentViewSelector'
import viewTypes from 'helpers/enums/viewTypes'
import formatLessonTypeFromView from 'helpers/lessonTypeFormatter'
import currentActivityIdSelector from '../selectors/activity_creation/current_activity_id_selector'
import upgradeSourceTypes from 'helpers/enums/metrics/upgradeSourceTypes'

function *duplicateActivity(jwt, currentSlideId, targetActivityUID, lessonType) {
	const { payload } = yield callAny(
		storeSync.duplicateActivity,
		jwt,
		currentSlideId,
		targetActivityUID,
		lessonType,
	)
	yield put(activityBanksActions.activityUpdated(payload))
}

function *duplicateCustomActivity(jwt, currentSlideId, targetActivityUID, lessonType) {
	const { payload } = yield callAny(
		storeSync.duplicateCustomActivity,
		jwt,
		currentSlideId,
		targetActivityUID,
		lessonType,
	)
	yield put(activityBanksActions.customActivityUpdated(payload))
}

function *handleActivitySelected(action) {
	const canReplaceFlag = yield select(canReplace)
	if (canReplaceFlag) {
		yield call(handleActivitySelectedConfirmed, action)
	}
}

function *handleActivitySelectedConfirmed(action) {
	try {
		yield put(activityBanksActions.activitySelectedStarted())

		const currentView = yield select(currentViewSelector)
		const lessonType = formatLessonTypeFromView(currentView)
		const currentSlideId = yield select(currentActivityIdSelector)
		const jwt = yield select(userDataJwtSelector)

		const customActivitiesViews = [
			viewTypes.TIME_TO_CLIMB_CREATION,
			viewTypes.TIME_TO_CLIMB_STANDALONE_CREATION,
		]

		if (customActivitiesViews.includes(currentView)) {
			yield call(
				duplicateCustomActivity,
				jwt,
				currentSlideId,
				action.lesson.data.entityUID,
				lessonType,
			)
		} else {
			yield call(
				duplicateActivity,
				jwt,
				currentSlideId,
				action.lesson.data.entityUID,
				lessonType,
			)
		}
	} catch (error) {
		const serverError = formatError(error)
		const upgradeSource = upgradeSourceTypes.ADD_ACTIVITY_BANK
		yield put(activityBanksActions.activityUpdateFailed(
			serverError,
			upgradeSource,
		))
	}
}

export default [
	takeLatest([
		actionTypes.ACTIVITY_BANKS_ACTIVITY_SELECTED,
	], handleActivitySelected),
	takeLatest([
		actionTypes.ACTIVITY_BANKS_ACTIVITY_SELECTED_CONFIRMED,
	], handleActivitySelectedConfirmed),
]

export {
	handleActivitySelected,
	handleActivitySelectedConfirmed,
}
